import React, { Component } from 'react';
import { Switch } from 'antd';
import classNames from 'classnames';

class SwitchField extends Component {
  render() {
    const {input, disabled, handleClick, meta: { touched, error }, placeholder, label, trueTitle, falseTitle } = this.props;
    return (
      <div className={classNames("create-dialog-form__group create-dialog-form__group--indent-bottom", {disabled})}>
        {label ? <label style={{width: '100%'}}>{label}</label> : null}
        <div style={{display: 'flex'}}>
          <Switch checked={input.value} onChange={(checked) => {
            if(handleClick){
              handleClick(checked, input);
              return;
            }
            input.onChange(checked)
          }} /> <span style={{marginLeft: 10,}}>{input.value ? trueTitle : falseTitle }</span>
        </div>
        
      </div>
    );
  }
}

export default SwitchField;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/helpers/Fields/SwitchField.jsx